var map = {
	"./GreyhoundRaces_dark_bg.jpg": 21878,
	"./VirtualGreyhoundRaces_dark_bg.jpg": 29993,
	"./VirtualHorseRaces_dark_bg.jpg": 45175,
	"./VirtualMotorcycleSpeedway_dark_bg.jpg": 41533
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 22270;